export const HISTORIC_ONLY: string = 'HistoricOnly'
export const INTEGRATION_MODE: string = 'IntegrationMode'
export const PARTITION_LICENCES: string = 'PartitionLicences'
export const TELSYS_TYPE: string = 'TelSysType'
export const MONITORING_ENABLED: string = 'MonitoringEnabled'
export const BOTS_DISABLED: string = 'BotsDisabled'
export const COMMS_ENABLED: string = 'CommsEnabled'

export const ADVANCED_FIELDS = {
    MAXIMUM_ALLOWED_USERS_MONITORED: 'MaximumAllowedUsersMonitored'
}
